/**
 * Types for Construction Site Submission Analysis
 */
import type { DesignerMission, DocumentType } from "../files/file-data.types";
import { actionTypes } from "@dune/vars";
import { ConstructionSiteDocumentType } from "./constructionSites.types";
import { DesignerType } from "../participants";

export type OperationType = Extract<(typeof actionTypes)[number], "EXTENSION" | "CONSTRUCTION" | "RENOVATION">;
export const RgaRisk = {
	FAIBLE: "FAIBLE",
	MODERE: "MODERE",
	IMPORTANT: "IMPORTANT",
} as const;
export type RgaRiskValues = typeof RgaRisk[keyof typeof RgaRisk];

export interface ConstructionSiteAnalysisData {
	constructionCost: number; // Coût de construction en €
	structuralDamage: boolean; // Atteinte aux structures porteuses
	underpinning: boolean; // Reprise en sous-œuvre
	operationType: OperationType; // Type d'opération
	createdArea: number; // m2 créé
	rgaRisk: RgaRiskValues; // Risque de RGA
	workStartDate: Date; // Date de démarrage des travaux
	hasG2AVP: boolean; // Présence d'une étude G2AVP
	floors?: number; // Nombre d'étages (selon type de bâtiment)
	basements?: number; // Nombre de sous-sols (selon type de bâtiment)
	sismic?: number; // Niveau sismique (0..4)
	designerRequirements?: DesignerAnalysis[]; // Calculated designer requirements from backend
}

export interface DesignerAnalysis {
	type: DesignerType;
	missions: DesignerMission[]
	declared: boolean;
	required: boolean;
}

export interface MissingDocument {
	typeLabel: string;
	participants: {
		id: number | null
		name: string;
	}[]
	documents?: string;
	comment?: string;
	documentType:ConstructionSiteDocumentType  ;
}

export interface DocumentToProcess {
	status: 'A_TRAITER';
	typeLabel: string;
	documentType: DocumentType;
	fileId: string;
	fileName: string;
	comment: string;
	participant?: {
		id: number
		name: string;
	};
}

export interface NonCompliantDocument {
	status: 'NON_CONFORME';
	typeLabel: string;
	documentType: DocumentType;
	fileId: string;
	fileName: string;
	comment: string;
	participant?: {
		id: number
		name: string;
	};
}

export interface SupportingDocumentsAnalysis {
	missingDocuments: MissingDocument[];
	documentsToProcess: DocumentToProcess[];
	nonCompliantDocuments: NonCompliantDocument[];
}

export const AnalysisSteps = {
	CONTROLS: 1,
	DEROGATION: 2,
	VALIDATION: 3,
} as const;

export type AnalysisStep = typeof AnalysisSteps[keyof typeof AnalysisSteps];
